import ACTION, { VEHICLEPASS_LIST_STATE, VEHICLEPASS_LIST_PENDING_STATE } from './creator'

const init = {
  status: VEHICLEPASS_LIST_STATE.PENDING,
  message: '',
  tableList: [],
}
const init_vp_pending = {
  status: VEHICLEPASS_LIST_PENDING_STATE.PENDING,
  message: '',
  tableList: {
    list: [],
    pagination: {
      page: 1,
      itemPerPage: 10,
      count: 0,
      totalCount: 0,
    },
  },
}

export const AuxVehiclePassTableByTenant = (state = init, { type, payload }) => {
  switch (type) {
    case ACTION.VEHICLEPASS_LIST.PENDING:
    case ACTION.VEHICLEPASS_LIST.SUCCESS:
    case ACTION.VEHICLEPASS_LIST.FAILURE:
      return { ...state, ...payload }
    default:
      return state
  }
}
export const AuxVehiclePassPendingTableByTenant = (state = init_vp_pending, { type, payload }) => {
  switch (type) {
    case ACTION.LIST_PENDING.PENDING:
    case ACTION.LIST_PENDING.SUCCESS:
      return { ...state, ...payload }
    case ACTION.LIST_PENDING.FAILURE:
      return { ...state, ...payload, tableList: init.tableList }
    default:
      return state
  }
}
